import { PersonsCreateService } from '@festina/legalentity-general-types/legalentity/services/PersonsCreateService'
import { useFestinaMutation } from '@festina-life/authentication'
import { assertNotEmpty } from '@festina-life/core'

import type { PersonCreationProps } from './usePersonCreationActions'

const method = PersonsCreateService.personCreateServicePostEdit
type MethodParam = NonNullable<Parameters<typeof method>[0]['requestBody']>

export const useUpdatePersonCreation = ({
  personId,
  tenantId,
  commandId,
}: PersonCreationProps) =>
  useFestinaMutation({
    component: 'legalEntity',
    roles: PersonsCreateService.personCreateServicePostEdit_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      assertNotEmpty(commandId)
      assertNotEmpty(personId)

      await method({
        xTenantId: tenantId,
        personId,
        requestBody: arg,
        commandId,
      })
    },
  })
